var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRouteLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 436 148"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#FAFAFA",
  strokeDasharray: "5 5",
  strokeLinecap: "round",
  strokeOpacity: 0.8,
  strokeWidth: 2,
  d: "M1 132.01s60.543 22.862 97.837 12.118c29.826-8.592 43.545-14.184 66.163-35.441m0 0s9.692-9.374 16.5-27.187C188.309 63.687 169 52 157 55c-12.242 3.06-21 17.742-14.5 29.237 7.5 13.263 6.809 11.95 22.5 24.45Zm0 0c17.685 11.783 29.258 14.434 50.5 13.813 22.539-.658 54.094-20.187 54.094-20.187m0 0c19.437-21.088 15.314-42.679-4.712-42.679-16.034 0-15.44 19.611-12.37 24.603 10.871 17.672 17.082 18.076 17.082 18.076Zm0 0C318.295 147.756 398 45.16 398 45.16"
})), /*#__PURE__*/React.createElement("mask", {
  id: "route-line_svg__a",
  width: 47,
  height: 46,
  x: 389,
  y: -1,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M389-1h46v46h-46z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#route-line_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FAFAFA",
  d: "M398.5 42.423a.5.5 0 0 1-.5-.5V6.5a.5.5 0 0 1 .5-.5h29.469a.25.25 0 0 1 .229.351l-3.9 8.825a.5.5 0 0 0 0 .405l3.9 8.825a.25.25 0 0 1-.229.35h-26.433a.5.5 0 0 0-.5.5v16.667a.5.5 0 0 1-.5.5zm2.536-21.202a.5.5 0 0 0 .5.5h21.842a.25.25 0 0 0 .228-.352l-2.605-5.785a.5.5 0 0 1 0-.41l2.605-5.786a.25.25 0 0 0-.228-.353h-21.842a.5.5 0 0 0-.5.5z"
}))));
export default SvgRouteLine;